import { render, staticRenderFns } from "./Return_stock.vue?vue&type=template&id=00a4551a&scoped=true&"
import script from "./Return_stock.vue?vue&type=script&lang=js&"
export * from "./Return_stock.vue?vue&type=script&lang=js&"
import style0 from "./Return_stock.vue?vue&type=style&index=0&id=00a4551a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a4551a",
  null
  
)

export default component.exports